import { defaultRules } from '../sim/build.ts';
import { initialProgress } from '../sim/progress.ts';
import { emptyGear, type BuildState, type SaveData, type SaveFile, type SubSpecId } from './types.ts';

export function starterBuild(): BuildState {
  return {
    primary: 'bulwark',
    secondary: 'banner',
    tertiary: 'echo',
    ranks: { bulwark: 1 },
  };
}

export function createNewSave(): SaveData {
  const build = starterBuild();
  return {
    hero: {
      name: 'Ash',
      level: 1,
      xp: 0,
      unspentPoints: 0,
      build,
      rules: defaultRules(build),
    },
    gear: {
      equipped: emptyGear(),
      bag: [],
      pity: { epicPlusSinceLegendary: 0 },
      nextItemId: 1,
      autoRecycleBelow: null,
    },
    currencies: { gold: 0, forgeDust: 0 },
    progress: initialProgress(),
    idle: {
      lastActiveAtMs: null,
      pendingClaim: false,
      snapshot: null,
      fightSerial: 1,
      farmBatch: null,
    },
  };
}

export function createNewFile(): SaveFile {
  return { version: 1, data: createNewSave() };
}

export function pointsSpent(build: BuildState): number {
  const ids = [build.primary, build.secondary, build.tertiary].filter((id): id is SubSpecId => id !== null);
  return ids.reduce((sum, id) => sum + (build.ranks[id] ?? 0), 0);
}
